/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cl_MenuInputs */

const en_cl_menu = /** @type {(inputs: Cl_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content language`)
};

const de_cl_menu = /** @type {(inputs: Cl_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltssprache`)
};

/**
* | output |
* | --- |
* | "Content language" |
*
* @param {Cl_MenuInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_menu = /** @type {((inputs?: Cl_MenuInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_MenuInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_menu(inputs)
	return en_cl_menu(inputs)
});